import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/dashboard/roster_care_team",
    component: MainPage,
    exact: false,
    name: "Roster - Equipo Cuidados"
  }
];

export default routes;
